/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const membershipResponseSchema = z.object({
  commitment: z.number(),
  commitmentOverridden: z.boolean(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  endDate: z.iso.date().nullish(),
  id: z.int(),
  instanceId: z.string().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  openPositionId: z.int().nullish(),
  organizationId: z.string(),
  resourceId: z.int().nullish(),
  roleId: z.int().nullish(),
  sourceCommitment: z.number(),
  sourceId: z.string().nullish(),
  startDate: z.iso.date().nullish(),
  teamId: z.int(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
